<ion-header>
    <ion-toolbar>

        <ion-title mode="ios" role="heading">{{ 'HOW_TO_DETAIL_TEXT_HEADER' | translate}}</ion-title>

        <ion-buttons slot="end">
            <ion-button
                class="icon-button-accessible-background-contrast"
                [attr.aria-label]="'ARIA_LABEL_CLOSE' | translate"
                (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <div *ngIf="isAndroid">
        <p [innerHTML]="'HOW_TO_DETAIL_TEXT_LOC_SERVICES_ANDROID_INTRO' | translate"></p>
        <ol class="decimal-list">
            <li [innerHTML]="'HOW_TO_DETAIL_TEXT_LOC_SERVICES_ANDROID_GO_TO_SETTINGS'     | translate"></li>
            <li [innerHTML]="'HOW_TO_DETAIL_TEXT_LOC_SERVICES_ANDROID_GO_TO_LOCATIONS'    | translate"></li>
            <li [innerHTML]="'HOW_TO_DETAIL_TEXT_LOC_SERVICES_ANDROID_SET_HIGH_ACCURACY'  | translate"></li>
        </ol>
    </div>
    <div *ngIf="!isAndroid">
        <p [innerHTML]="'HOW_TO_DETAIL_TEXT_LOC_SERVICES_IOS_INTRO' | translate"></p>
        <ol class="decimal-list">
            <li [innerHTML]="'HOW_TO_DETAIL_TEXT_LOC_SERVICES_IOS_GO_TO_SETTINGS'     | translate"></li>
            <li [innerHTML]="'HOW_TO_DETAIL_TEXT_LOC_SERVICES_IOS_GO_TO_LOCATIONS'    | translate"></li>
            <li [innerHTML]="'HOW_TO_DETAIL_TEXT_LOC_SERVICES_IOS_TURN_ON_LOCATIONS'  | translate"></li>
            <li [innerHTML]="'HOW_TO_DETAIL_TEXT_LOC_SERVICES_IOS_FIND_RMOVE'         | translate"></li>
            <li [innerHTML]="'HOW_TO_DETAIL_TEXT_LOC_SERVICES_IOS_SET_ALWAYS_ALLOW'   | translate"></li>
        </ol>
    </div>
</ion-content>